import { MuiButton } from '@/components/button/MuiButton';
import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useLogic } from './logic';
import {
  api_portalOfficeHospitalListing_medicalSubject,
  api_portalOfficeHospitalListing_reportedAdditionalFee,
} from '@/init/swagger';
import { Fragment } from 'react';

type Props = {
  hospitalMedicalSubjects: api_portalOfficeHospitalListing_medicalSubject[];
  hospitalReportedAdditionalFees: api_portalOfficeHospitalListing_reportedAdditionalFee[];
  search: () => Promise<void>;
  close: () => void;
};

export function MedicalSubjectContent({
  hospitalMedicalSubjects,
  hospitalReportedAdditionalFees,
  search,
  close,
}: Props) {
  const {
    items,
    itemsReportedAdditionalFees,
    toggle,
    toggleReportedAdditionalFees,
    onClear,
    onSubmit,
  } = useLogic({
    hospitalMedicalSubjects,
    hospitalReportedAdditionalFees,
    search,
    close,
  });

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <Typography variant="JP/Heading/m/Bold/Tight" sx={{ flex: 1 }}>
          診療科目・届出加算で絞る
        </Typography>

        <MuiButton variant="text" sx={{ color: '#000' }} onClick={close}>
          とじる
          <ClearIcon />
        </MuiButton>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '28% 1fr',
          alignItems: 'baseline',
          rowGap: 2,
        }}
      >
        <Typography
          variant="JP/Body/m/Medium/Tight"
          sx={{
            gridRow: 1,
            gridColumn: 1,
            '@media (max-width: 880px)': {
              gridRow: 1,
              gridColumn: '1 / span 2',
            },
          }}
        >
          診療科目
        </Typography>

        <Box
          sx={{
            gridRow: 1,
            gridColumn: 2,
            '@media (max-width: 880px)': {
              gridRow: 2,
              gridColumn: '1 / span 2',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
              flexWrap: 'wrap',
              flexGrow: 1,
              rowGap: 2,
              columnGap: 3,
              maxWidth: '100%',
            }}
          >
            {items.map(({ id, label, checked }) => {
              return (
                <Fragment key={id}>
                  {id != null && (
                    <FormGroup
                      sx={{
                        backgroundColor: 'bg.lighter',
                        alignItems: 'center',
                      }}
                    >
                      <FormControlLabel
                        label={label}
                        style={{
                          marginLeft: '0rem',
                          marginRight: 2,
                        }}
                        control={
                          <Checkbox
                            checked={checked}
                            onChange={(e) => toggle(e, id)}
                            name={label}
                            sx={{ p: 0 }}
                          />
                        }
                      />
                    </FormGroup>
                  )}
                </Fragment>
              );
            })}
          </Box>
        </Box>
      </Box>

      <Divider />

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '28% 1fr',
          alignItems: 'baseline',
          rowGap: 2,
        }}
      >
        <Typography
          variant="JP/Body/m/Medium/Tight"
          sx={{
            gridRow: 1,
            gridColumn: 1,
            '@media (max-width: 880px)': {
              gridRow: 1,
              gridColumn: '1 / span 2',
            },
          }}
        >
          在宅医療に関する届出加算
          {/* TODO: 変更あるかも 短くなったらgridTemplateColumnsを20%に戻す */}
        </Typography>

        <Box
          sx={{
            gridRow: 1,
            gridColumn: 2,
            '@media (max-width: 880px)': {
              gridRow: 2,
              gridColumn: '1 / span 2',
            },
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
              flexWrap: 'wrap',
              flexGrow: 1,
              rowGap: 2,
              columnGap: 3,
              maxWidth: '100%',
            }}
          >
            {itemsReportedAdditionalFees.map(({ id, label, checked }) => {
              return (
                <Fragment key={id}>
                  {id != null && (
                    <FormGroup
                      sx={{
                        backgroundColor: 'bg.lighter',
                        alignItems: 'center',
                      }}
                    >
                      <FormControlLabel
                        label={label}
                        style={{
                          marginLeft: '0rem',
                          marginRight: 2,
                        }}
                        control={
                          <Checkbox
                            checked={checked}
                            onChange={(e) =>
                              toggleReportedAdditionalFees(e, id)
                            }
                            name={label}
                            sx={{ p: 0 }}
                          />
                        }
                      />
                    </FormGroup>
                  )}
                </Fragment>
              );
            })}
          </Box>
        </Box>
      </Box>

      <Divider />

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'end',
          my: 2,
          gap: 1,
        }}
      >
        <MuiButton color="primary" variant="text" onClick={onClear}>
          選択中のフィルターをクリア
        </MuiButton>

        <MuiButton color="primary" onClick={onSubmit}>
          検索
        </MuiButton>
      </Box>
    </>
  );
}
